
export default {
  methods: {
    decodeFace(content) {
      let cmtContent = content
      const re = /\[([a-z0-9_]+?)\]/
      const reg = /\[([a-z0-9_]+?)\]/g
      const matRlt = cmtContent.match(reg)
      if (matRlt) {
        for (const face of matRlt) {
          const faceName = face.match(re)[1]
          cmtContent = cmtContent.replace(face, '<img style="width:24px;height:24px;vertical-align: middle" ' +
            'src="http://m.shicigl.com/00/face/' + faceName + '.png" />')
        }
      }
      return cmtContent
    }
  }
}
